/** The Synchronisaties screen (ADR-0067): one card per bron, each with the button that runs it now. */
export const synchronisaties = {
  bronnen: {
    portaal: {
      naam: "JBNL Portaal",
      wat: "Korpsen, jeugdleiders, korpscontacten, regiocontacten en wie beheerder is.",
    },
    vbs: {
      naam: "VBS",
      wat: "De ondersteuners die VBS bijhoudt, met hun naam en adres.",
    },
  },

  status: {
    nooit: "Nog niet uitgevoerd",
    bezig: "Bezig",
    geslaagd: "Geslaagd",
    mislukt: "Mislukt",
  },

  laatsteKeer: "Laatste keer:",
  volgendeKeer: "Volgende keer:",
  nogNietGelopen: "nooit",
  /** What an environment without a nightly schedule says. The button works there too. */
  nietIngepland: "niet ingepland in deze omgeving",

  nuSynchroniseren: "Nu synchroniseren",
  bezig: "Bezig met synchroniseren",

  /** Above the message, to tell a retry apart from a run that has given up. */
  pogingMislukt:
    "De vorige poging is mislukt. De synchronisatie start vanzelf opnieuw.",
  synchronisatieMislukt: "De synchronisatie is mislukt.",

  geenAchtergrondservice:
    "De achtergrondservice draait niet. Een synchronisatie start pas als deze service weer draait.",

  errors: {
    ophalen: "Kon de synchronisaties niet ophalen.",
    starten: "Kon de synchronisatie niet starten.",
  },
} as const;
